module.exports = __webpack_public_path__ + "static/media/TermsandConditions.303804bb.pdf";